import { defineMessages } from "react-intl";

import {
	resultMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/viral-serology/treponemaPallidum";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	treponemaPallidum: {
		id: "ktx.treponemaPallidum.title",
		defaultMessage: "Treponema pallidum (szifilisz)"
	},
	result: {
		id: "ktx.treponemaPallidum.field.result",
		defaultMessage: "Eredmény"
	}
});

const fields: { [key: string]: FieldData } = {
	result: {
		type: "field",
		path: ["result"],
		label: messages.result,
		errorMessages: genericErrorMessages,
		input: { type: "button-group", props: { labels: resultMessages } }
	}
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: fields.result }] }]
};

export const node: LeafNode = {
	id: "ktx_treponemaPallidum",
	value: {
		schemaId: "treponemaPallidum",
		title: messages.treponemaPallidum,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
